import { ca } from '@cian/analytics';

interface ITrackNewReviewArgs {
  objectId: number;
}

export const trackNewReviewButton = ({ objectId }: ITrackNewReviewArgs) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DailyrentReviews',
    action: 'click',
    label: 'Write_Review',
    page: { pageType: 'ReviewsDailyrent', siteType: 'desktop' },
    products: [{ id: objectId, offerType: 'offer' }],
  });
};
